export const getInitialLocale = () => {
	return localStorage.locale || "ka";
};
